import { NgModule } from '@angular/core';
import { MonitorDataRoutingModule } from './monitor-data-routing.module';
import { MonitorDataComponent } from './monitor-data.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { JobsService } from '../../admin/scheduler-config/jobs.service';


@NgModule({
  declarations: [
    MonitorDataComponent
  ],
  imports: [
    CommonModule,
    MonitorDataRoutingModule,
    SharedModule
  ],
  exports: [
    MonitorDataComponent
  ],
  providers: [JobsService]
})
export class MonitorDataModule { }


